import type { GetAssessmentCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetAssessmentCount = createQueryHook<
  Record<string, never>,
  number,
  GetAssessmentCountQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.assessment.assessmentCount.queryOptions(),
  // Pass the count straight through (not `data ?? 0`): the createQueryHook
  // factory already surfaces undefined while loading, so a genuine 0 must
  // stay 0 rather than be masked by a coerced fallback.
  mapTrpcDataToGraphQL: (data) => ({
    assessment_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  graphqlDocument: GetAssessmentCountDocument,
});
